import { useMemo } from "react";
import { useGetEntityData } from "./useGetEntityData";
import {
  getNotificationCuiStatus,
  getNotificationDimensiuneStatus,
  getNotificationServiciiStatus,
  getNotificationClasificareStatus,
  getNotificationPdfStatus,
} from "@/utils/guideProgressCalculator";
import type { GuideStepStatus } from "@/types/guide-step";
import type { EntityData } from "@/types/entity";

export type NotificationStep = {
  id: number;
  status: GuideStepStatus;
};

export type NotificationGuideProgressResult = {
  steps: {
    step1: NotificationStep;
    step2: NotificationStep;
    step3: NotificationStep;
    step4: NotificationStep;
    step5: NotificationStep;
  };
  isLoading: boolean;
  hasSession: boolean;
  entityData: EntityData | null | undefined;
};

export function useNotificationGuideProgress(
  sessionId: string | null | undefined
): NotificationGuideProgressResult {
  const { data: entityDataResponse, isLoading: isLoadingEntity } =
    useGetEntityData(sessionId, {
      enabled: !!sessionId,
    });

  const entityData = entityDataResponse?.entity_data;

  const steps = useMemo(() => {
    return {
      step1: {
        id: 1,
        status: getNotificationCuiStatus(entityData),
      },
      step2: {
        id: 2,
        status: getNotificationDimensiuneStatus(entityData),
      },
      step3: {
        id: 3,
        status: getNotificationServiciiStatus(entityData),
      },
      step4: {
        id: 4,
        status: getNotificationClasificareStatus(entityData),
      },
      step5: {
        id: 5,
        status: getNotificationPdfStatus(entityData),
      },
    };
  }, [entityData]);

  return {
    steps,
    isLoading: isLoadingEntity,
    hasSession: !!sessionId,
    entityData,
  };
}
